<template>
  <div class="popup z-index-10-fg confirmation small-popup confirm-popup">
    <div class="popup-content">
      <div class="popup-header">
        <h2>{{ header }}</h2>
        <img src="../assets/close.svg" alt="" class="popup-close" @click="$emit('cancel')" />
      </div>
      <div class="popup-body">
        <p>{{ message }}</p>
      </div>
      <div class="popup-footer">
        <button @click="$emit('cancel')" class="text-btn">{{ cancelText }}</button>
        <button @click="$emit('confirm')" class="square-btn">{{ confirmText }}</button>
      </div>
    </div>
  </div>
  <div class="screen-overlay-gray z-index-10-bg"></div>
</template>

<script>
export default {
  name: 'Confirmation',
  emits: ['confirm', 'cancel'],
  props: {
    header: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    confirmText: {
      type: String,
      required: true,
    },
    cancelText: {
      type: String,
      required: true,
    },
    serious: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.confirm-popup {
  width: 25rem;
}
</style>
